<script>
import { mapGetters } from 'vuex'
import { getDistricts } from '@/api/assetwise'

export default {
  props: {
    provinceId: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      items: [{ value: '', text: this.$t('All') }],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    provinceId: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.items = [{ value: '', text: this.$t('All') }]
          return
        }
        this.fetchItems()
      }
    }
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const items = await getDistricts({
          page_id: this.selectedBot.pageid,
          province_id: this.provinceId
        }).then((response) => {
          const { data = [] } = response.data
          return data
        })

        this.items = [
          { value: '', text: this.$t('All') },
          ...items.map((item) => ({
            value: item.DistrictID,
            text: item.DistrictName
          }))
        ]
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      options: this.items,
      loading: this.isLoading
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/providers/DistrictOptionListProvider.vue